import React, { Component } from "react";
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';

export default class UserRoles extends Component {
  constructor(props) {
    super(props);
    let privileges = this.props.privileges;
    this.state = {
      checkboxes: [],
      selectAll: false,
      checkBoxState: false,
      listCheckbox: privileges,
      stringRoles: [],
      testState: true
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultRoles !== this.props.defaultRoles) {
      if (this.state.testState) {
        for (let i = 0; i < this.state.listCheckbox.length; i++) {
          this.state.listCheckbox[i].checked = "false";
        }

        nextProps.defaultRoles.map((role, index) => {
          this.state.listCheckbox.find(obj => {
            if (obj.sortNO == role.sortNO) {
              this.state.listCheckbox[obj.sortNO - 1].checked = "true";
            }
          });
        });

        this.setState({ checkboxes: nextProps.defaultRoles });
      }
    }
  }

  checkAllResponsibility(isChecked) {
    const state = this.state;
    this.setState({
      selectAll: isChecked
    });

    let object;
    if (isChecked) {
      state.listCheckbox.map((role, index) => {
        object = new Object();
        object.id = role.id;
        object.roleType = role.roleType;
        object.name = role.name;
        object.sortNO = role.sortNO;
        state.checkboxes.push(object);
        state.listCheckbox[index].checked = "true";
      });
    } else {
      state.checkboxes = [];

      state.listCheckbox.map((item, index) => {
        state.listCheckbox[index].checked = "false";
      });
    }

    this.props.getAllUserPrivilege(state.checkboxes);
  }

  addIntoArray = id => event => {
    const state = this.state;

    let index = 0;
    let checkbox = id
    let object;
    let getCheckBoxState = state.listCheckbox[checkbox - 1].checked;

    if (!getCheckBoxState || getCheckBoxState == "false") {
      object = new Object();
      state.listCheckbox.map((role, index) => {
        if (checkbox == role.sortNO) {
          object.id = role.id;
          object.roleType = role.roleType;
          object.name = role.name;
          object.sortNO = role.sortNO;
          state.checkboxes.push(object);
          return;
        }
      });
      state.listCheckbox[checkbox - 1].checked = "true";
    } else {
      state.listCheckbox.map((role, index) => {
        if (checkbox == role.sortNO) {
          index = state.checkboxes.findIndex(role => {
            return role.sortNO == checkbox;
          });
          state.checkboxes.splice(index, 1);
        }
      });
      state.listCheckbox[checkbox - 1].checked = "false";
    }
    this.props.getAllUserPrivilege(state.checkboxes);
  }

  render() {
    const { roleTitle } = this.props;
    return (
      <div style={styles.toggleContainer}>
        <FormControl component="fieldset" >
          <FormLabel component="legend">Assign responsibility</FormLabel>
          {this.state.listCheckbox.map((role, index) => {
            return (
              <FormControlLabel
                control={
                  <Checkbox
                  checked={role.checked === "true"}
                  onChange={this.addIntoArray(role.sortNO)}
                  id={role.sortNO}
                  name={role.name}
                  value="gilad" />
                }
                label={role.name}
              />
            );
          })}
        </FormControl>
      </div>
    );
  }
}

const styles = {
  toggleContainer: {
    display: "flex",
    flexWrap: "wrap"
  },
  toggleHeader: {
    width: "100%"
  }
};
